import { Team__Nogaleras } from "./teams/Nogaleras";
import { Team__Potras } from "./teams/Potras";
import { Team__Pythons } from "./teams/Pythons";
import { Team__Raptors } from "./teams/Raptors";
import { Team__UTPaquime } from "./teams/UTPaquime";

const GroupA = [
  Team__Nogaleras,
  Team__Potras,
  Team__Pythons,
  Team__Raptors,
  Team__UTPaquime,
];

export const Groups_2025_womens = [GroupA];
